import { string, object, array } from 'yup';

export const validationSchema = array().of(
  object().shape({
    title: string().min(5, 'Document title is required'),
  }),
);
